module.exports = __webpack_public_path__ + "static/img/131.f3e2b88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/131.jpg
// module id = ytGK
// module chunks = 0